import { type FC, type MouseEvent, useState } from "react";

import type { BlockVariantType } from "../../../../shared/types/worksheet";

import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { IconText } from "mds/components/IconText";
import { PresentPlayBackgroundIcon } from "mds/icons/PresentPlayBackground";
import { useAppSelector } from "store/index";
import { pageSelectors, selectActiveClassSessionId } from "store/selectors";
import { FeatureOptions, featurePage } from "utils/presentation";

export type FeatureButtonProps = FeatureOptions & {
  pageId: string;
  blockType?: BlockVariantType;
  size?: "s" | "m" | "l";
};

export const FeatureButton: FC<FeatureButtonProps> = ({
  pageId,
  blockType,
  size = "s",
  ...options
}) => {
  const classSessionId = useAppSelector(selectActiveClassSessionId);
  const page = useAppSelector((s) => pageSelectors.selectById(s, pageId));

  const [isHovering, setIsHovering] = useState<boolean>(false);

  const setFeature = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (classSessionId && page) {
      featurePage(classSessionId, page, options);
    }
  };

  return (
    <Button
      className={!isHovering ? "ml-[1px]" : undefined}
      eventName="New feature button"
      eventProps={{ blockType }}
      kind={isHovering ? "feature" : "transparentSquareLegacy"}
      size={size}
      title={t("presentation.feature")}
      onClick={setFeature}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {isHovering ? (
        <IconText
          iconStart={<PresentPlayBackgroundIcon className="text-green" />}
          text={t("presentation.feature")}
        />
      ) : (
        <PresentPlayBackgroundIcon className="text-green" />
      )}
    </Button>
  );
};
